import ProvidersList from "./list";
import './index.css'
const Providers = () => {

     return (
         <ProvidersList />
    )

}

export default Providers
